import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { QaiIconComponent, QaiLinkComponent } from '@qai/ui';

@Component({
  selector: 'app-call-pathway-error',
  standalone: true,
  imports: [CommonModule, TranslocoModule, QaiIconComponent, QaiLinkComponent],
  templateUrl: './call-pathway-error.component.html',
  styleUrls: ['./call-pathway-error.component.scss'],
})
export class CallPathwayErrorComponent {}
